// To keep the log a manageable length, please limit the number of releases listed here to 5.
// If you are adding a 6th entry, please remove the oldest entry so that the total remains at 5.

const VersionLog = `

### Version 5.15.2 - July 31, 2026

- Patient create and update requests now call the V1 API endpoint, enabling downstream Patient Created and Patient Updated event publishing.

---

### Version 5.15.1 - July 13, 2026

- Fixes bug where the Bad Lead disposition on the Search step would not end or disposition Digital contacts.

---

### Version 5.15.0 - July 06, 2026

- No user-facing changes. Adds support for the new InContact update to 'digital first omnichannel'. This should allow the dispositions in MAX for SMS/Chat/Email contacts to continue to be automatically set when completing the Disposition step in GEM.

---

### Version 5.14.4 - June 10, 2026

- Update identity provider to support SSO after Zenoti migration to Azure.

---

### Version 5.14.3 - April 09, 2026

- The date and time fields will now allow you to type in the values directly, and will automatically format them as you type. This should make it easier to enter values without having to use the date and time pickers.
- The date will be saved and will not block you from entering into the booking step.

---

### Version 5.14.2 - March 19, 2026

- The date and time fields will now allow you to type in the values directly, and will automatically format them as you type. This should make it easier to enter values without having to use the date and time pickers.

---

`;

export default VersionLog;
